import React from 'react';
import PropTypes from "prop-types";
import { css } from '@emotion/react';
// @ts-ignore NOT TS yet
import { humanizeType } from '../../services/playground/knobs';
export var EuiTheme = function EuiTheme() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeColors = function EuiThemeColors() {
  return ___EmotionJSX("div", null);
};
EuiThemeColors.propTypes = {
  /**
     * Main brand color and used for most **call to actions** like buttons and links.
     */
  primary: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Pulls attention to key indicators like **notifications** or number of selections.
     */
  accent: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used for **positive** messages/graphics and additive actions.
     */
  success: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used for **warnings** and actions that have a potential to be destructive.
     */
  warning: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used for **negative** messages/graphics like errors and destructive actions.
     */
  danger: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Typically computed against `colors.primary`
     */
  primaryText: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Typically computed against `colors.accent`
     */
  accentText: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Typically computed against `colors.success`
     */
  successText: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Typically computed against `colors.warning`
     */
  warningText: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Typically computed against `colors.danger`
     */
  dangerText: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used as the background color of primary **page content and panels** including modals and flyouts.
     */
  emptyShade: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used to lightly shade areas that contain **secondary content** or contain panel-like components.
     */
  lightestShade: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used for most **borders** and dividers (horizontal rules).
     */
  lightShade: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * The middle gray for all themes; this is the base for `colors.subdued`.
     */
  mediumShade: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Slightly subtle graphic color
     */
  darkShade: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used as the **text** color and the background color for **inverted components** like tooltips and the control bar.
     */
  darkestShade: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * The opposite of `emptyShade`
     */
  fullShade: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * The background color for the **whole window (body)** and is a computed value of `colors.lightestShade`.
     * Provides denominator (background) value for **contrast calculations**.
     */
  body: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Used to **highlight text** when matching against search strings
     */
  highlight: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Computed against `colors.darkestShade`
     */
  disabled: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Computed against `colors.disabled`
     */
  disabledText: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * The base color for shadows that gets `transparentized`
     * at a value based on the `colorMode` and then layered.
     */
  shadow: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Computed against `colors.darkestShade`
     */
  text: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Computed against `colors.text`
     */
  title: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Computed against `colors.mediumShade`
     */
  subduedText: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Computed against `colors.primaryText`
     */
  link: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired
};
export var EuiThemeConstantColors = function EuiThemeConstantColors() {
  return ___EmotionJSX("div", null);
};
EuiThemeConstantColors.propTypes = {
  /**
     * Purest **white**
     */
  ghost: PropTypes.string.isRequired,
  /**
     * Purest **black**
     */
  ink: PropTypes.string.isRequired
};
export var EuiThemeSize = function EuiThemeSize() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeFontBase = function EuiThemeFontBase() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeFontWeight = function EuiThemeFontWeight() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeFontScale = function EuiThemeFontScale() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeBody = function EuiThemeBody() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeBorderRadiusValues = function EuiThemeBorderRadiusValues() {
  return ___EmotionJSX("div", null);
};
EuiThemeBorderRadiusValues.propTypes = {
  /**
     * Primary corner radius size
     */
  medium: PropTypes.any.isRequired,
  /**
     * Small corner radius size
     */
  small: PropTypes.any.isRequired
};
export var EuiThemeBorderWidthValues = function EuiThemeBorderWidthValues() {
  return ___EmotionJSX("div", null);
};
EuiThemeBorderWidthValues.propTypes = {
  /**
     * Thinnest width for border
     */
  thin: PropTypes.any.isRequired,
  /**
     * Thickest width for border
     */
  thick: PropTypes.any.isRequired
};
export var EuiThemeBorderColorValues = function EuiThemeBorderColorValues() {
  return ___EmotionJSX("div", null);
};
EuiThemeBorderColorValues.propTypes = {
  /**
     * Color for all borders; Default is `colors.lightShade`
     */
  color: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired
};
export var EuiThemeBorderTypes = function EuiThemeBorderTypes() {
  return ___EmotionJSX("div", null);
};
EuiThemeBorderTypes.propTypes = {
  /**
     * Full `border` property string computed using `border.width.thin` and `border.color`
     */
  thin: PropTypes.any.isRequired,
  /**
     * Full `border` property string computed using `border.width.thick` and `border.color`
     */
  thick: PropTypes.any.isRequired,
  /**
     * Full editable style `border` property string computed using `border.width.thick` and `border.color`
     */
  editable: PropTypes.any.isRequired
};
export var EuiThemeFocus = function EuiThemeFocus() {
  return ___EmotionJSX("div", null);
};
EuiThemeFocus.propTypes = {
  /**
     * Default color of the focus ring, some components may override this property
     */
  color: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.any.isRequired]).isRequired,
  /**
     * Thickness of the outline
     */
  width: PropTypes.any.isRequired
};
export var EuiThemeAnimationSpeed = function EuiThemeAnimationSpeed() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeAnimationEasing = function EuiThemeAnimationEasing() {
  return ___EmotionJSX("div", null);
};
export var euiThemeBreakpointType = {
  custom: {
    origin: {
      type: {
        name: 'number'
      }
    }
  }
};
export var EuiThemeLevelsProps = () => <div />;
export function getType(type, euiTheme) {
  let typeRender;
  if (type?.custom?.origin?.type) {
    typeRender = <span css={/*#__PURE__*/css("font-weight:", euiTheme.font.weight.light, ";color:", euiTheme.colors.subduedText, ";;label:typeRender;")}>
        {humanizeType(type.custom.origin.type)}
      </span>;
  }
  return typeRender;
}
try {
  EuiTheme.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiTheme',
    methods: [],
    props: {
      colors: {
        defaultValue: null,
        description: '',
        name: 'colors',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeColors'
        }
      },
      base: {
        defaultValue: null,
        description: '',
        name: 'base',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      size: {
        defaultValue: null,
        description: '',
        name: 'size',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeSizes'
        }
      },
      font: {
        defaultValue: null,
        description: '',
        name: 'font',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeFont'
        }
      },
      border: {
        defaultValue: null,
        description: '',
        name: 'border',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeBorder'
        }
      },
      focus: {
        defaultValue: null,
        description: '',
        name: 'focus',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeFocus'
        }
      },
      animation: {
        defaultValue: null,
        description: '',
        name: 'animation',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeAnimation'
        }
      },
      breakpoint: {
        defaultValue: null,
        description: '',
        name: 'breakpoint',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeBreakpoints'
        }
      },
      levels: {
        defaultValue: null,
        description: '',
        name: 'levels',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/services/theme/types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeLevels'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeColors.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeColors',
    methods: [],
    props: {
      primary: {
        defaultValue: null,
        description: 'Main brand color and used for most **call to actions** like buttons and links.',
        name: 'primary',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      accent: {
        defaultValue: null,
        description: 'Pulls attention to key indicators like **notifications** or number of selections.',
        name: 'accent',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      success: {
        defaultValue: null,
        description: 'Used for **positive** messages/graphics and additive actions.',
        name: 'success',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      warning: {
        defaultValue: null,
        description: 'Used for **warnings** and actions that have a potential to be destructive.',
        name: 'warning',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      danger: {
        defaultValue: null,
        description: 'Used for **negative** messages/graphics like errors and destructive actions.',
        name: 'danger',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      primaryText: {
        defaultValue: null,
        description: 'Typically computed against `colors.primary`',
        name: 'primaryText',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      accentText: {
        defaultValue: null,
        description: 'Typically computed against `colors.accent`',
        name: 'accentText',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      successText: {
        defaultValue: null,
        description: 'Typically computed against `colors.success`',
        name: 'successText',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      warningText: {
        defaultValue: null,
        description: 'Typically computed against `colors.warning`',
        name: 'warningText',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      dangerText: {
        defaultValue: null,
        description: 'Typically computed against `colors.danger`',
        name: 'dangerText',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      emptyShade: {
        defaultValue: null,
        description: 'Used as the background color of primary **page content and panels** including modals and flyouts.',
        name: 'emptyShade',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      lightestShade: {
        defaultValue: null,
        description: 'Used to lightly shade areas that contain **secondary content** or contain panel-like components.',
        name: 'lightestShade',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      lightShade: {
        defaultValue: null,
        description: 'Used for most **borders** and dividers (horizontal rules).',
        name: 'lightShade',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      mediumShade: {
        defaultValue: null,
        description: 'The middle gray for all themes; this is the base for `colors.subdued`.',
        name: 'mediumShade',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      darkShade: {
        defaultValue: null,
        description: 'Slightly subtle graphic color',
        name: 'darkShade',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      darkestShade: {
        defaultValue: null,
        description: 'Used as the **text** color and the background color for **inverted components** like tooltips and the control bar.',
        name: 'darkestShade',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      fullShade: {
        defaultValue: null,
        description: 'The opposite of `emptyShade`',
        name: 'fullShade',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      body: {
        defaultValue: null,
        description: 'The background color for the **whole window (body)** and is a computed value of `colors.lightestShade`.\n' + 'Provides denominator (background) value for **contrast calculations**.',
        name: 'body',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      highlight: {
        defaultValue: null,
        description: 'Used to **highlight text** when matching against search strings',
        name: 'highlight',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'Computed against `colors.darkestShade`',
        name: 'disabled',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      disabledText: {
        defaultValue: null,
        description: 'Computed against `colors.disabled`',
        name: 'disabledText',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      shadow: {
        defaultValue: null,
        description: 'The base color for shadows that gets `transparentized`\n' + 'at a value based on the `colorMode` and then layered.',
        name: 'shadow',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      text: {
        defaultValue: null,
        description: 'Computed against `colors.darkestShade`',
        name: 'text',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      title: {
        defaultValue: null,
        description: 'Computed against `colors.text`',
        name: 'title',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      subduedText: {
        defaultValue: null,
        description: 'Computed against `colors.mediumShade`',
        name: 'subduedText',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      link: {
        defaultValue: null,
        description: 'Computed against `colors.primaryText`',
        name: 'link',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeConstantColors.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeConstantColors',
    methods: [],
    props: {
      ghost: {
        defaultValue: null,
        description: 'Purest **white**',
        name: 'ghost',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      ink: {
        defaultValue: null,
        description: 'Purest **black**',
        name: 'ink',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/colors.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeSize.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeSize',
    methods: [],
    props: {
      base: {
        defaultValue: null,
        description: '',
        name: 'base',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      s: {
        defaultValue: null,
        description: '',
        name: 's',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      m: {
        defaultValue: null,
        description: '',
        name: 'm',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      xs: {
        defaultValue: null,
        description: '',
        name: 'xs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      l: {
        defaultValue: null,
        description: '',
        name: 'l',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      xl: {
        defaultValue: null,
        description: '',
        name: 'xl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      xxl: {
        defaultValue: null,
        description: '',
        name: 'xxl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      xxs: {
        defaultValue: null,
        description: '',
        name: 'xxs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      xxxl: {
        defaultValue: null,
        description: '',
        name: 'xxxl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      xxxxl: {
        defaultValue: null,
        description: '',
        name: 'xxxxl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFontBase.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFontBase',
    methods: [],
    props: {
      family: {
        defaultValue: null,
        description: 'The whole font family stack for all parts of the UI.\n' + 'We encourage only customizing the first font in the stack.',
        name: 'family',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      familyCode: {
        defaultValue: null,
        description: 'The font family used for monospace UI elements like EuiCode',
        name: 'familyCode',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      familySerif: {
        defaultValue: null,
        description: 'The font family used for serif UI elements like blockquotes within EuiText',
        name: 'familySerif',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      featureSettings: {
        defaultValue: null,
        description: 'Controls advanced features OpenType fonts.\n' + 'https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings',
        name: 'featureSettings',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      baseline: {
        defaultValue: null,
        description: 'A computed number that is 1/4 of `base`',
        name: 'baseline',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      lineHeightMultiplier: {
        defaultValue: null,
        description: 'Establishes the ideal line-height percentage, but it is the `baseline` integer that establishes the final pixel/rem value',
        name: 'lineHeightMultiplier',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFontWeight.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFontWeight',
    methods: [],
    props: {
      light: {
        defaultValue: null,
        description: '',
        name: 'light',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      bold: {
        defaultValue: null,
        description: '',
        name: 'bold',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      regular: {
        defaultValue: null,
        description: '',
        name: 'regular',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      medium: {
        defaultValue: null,
        description: '',
        name: 'medium',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      semiBold: {
        defaultValue: null,
        description: '',
        name: 'semiBold',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'FontWeight'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFontScale.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFontScale',
    methods: [],
    props: {
      s: {
        defaultValue: null,
        description: '',
        name: 's',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      m: {
        defaultValue: null,
        description: '',
        name: 'm',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xs: {
        defaultValue: null,
        description: '',
        name: 'xs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      l: {
        defaultValue: null,
        description: '',
        name: 'l',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xl: {
        defaultValue: null,
        description: '',
        name: 'xl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xxl: {
        defaultValue: null,
        description: '',
        name: 'xxl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xxxs: {
        defaultValue: null,
        description: '',
        name: 'xxxs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xxs: {
        defaultValue: null,
        description: '',
        name: 'xxs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBody.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBody',
    methods: [],
    props: {
      scale: {
        defaultValue: null,
        description: 'A sizing key from one of the font scales to set as the base body font-size',
        name: 'scale',
        parent: {
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: '_EuiThemeBody'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: '_EuiThemeBody'
        }],
        required: true,
        type: {
          name: 'enum',
          raw: '"s" | "m" | "xs" | "l" | "xl" | "xxl" | "xxxs" | "xxs"',
          value: [{
            value: '"s"'
          }, {
            value: '"m"'
          }, {
            value: '"xs"'
          }, {
            value: '"l"'
          }, {
            value: '"xl"'
          }, {
            value: '"xxl"'
          }, {
            value: '"xxxs"'
          }, {
            value: '"xxs"'
          }]
        }
      },
      weight: {
        defaultValue: null,
        description: 'A font weight key for setting the base body weight',
        name: 'weight',
        parent: {
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: '_EuiThemeBody'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/typography.ts',
          name: '_EuiThemeBody'
        }],
        required: true,
        type: {
          name: 'enum',
          raw: '"light" | "bold" | "regular" | "medium" | "semiBold"',
          value: [{
            value: '"light"'
          }, {
            value: '"bold"'
          }, {
            value: '"regular"'
          }, {
            value: '"medium"'
          }, {
            value: '"semiBold"'
          }]
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderRadiusValues.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderRadiusValues',
    methods: [],
    props: {
      medium: {
        defaultValue: null,
        description: 'Primary corner radius size',
        name: 'medium',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderRadiusValues'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderRadiusValues'
        }],
        required: true,
        type: {
          name: 'BorderRadius<string | number>'
        }
      },
      small: {
        defaultValue: null,
        description: 'Small corner radius size',
        name: 'small',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderRadiusValues'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderRadiusValues'
        }],
        required: true,
        type: {
          name: 'BorderRadius<string | number>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderWidthValues.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderWidthValues',
    methods: [],
    props: {
      thin: {
        defaultValue: null,
        description: 'Thinnest width for border',
        name: 'thin',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderWidthValues'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderWidthValues'
        }],
        required: true,
        type: {
          name: 'BorderWidth<string | number>'
        }
      },
      thick: {
        defaultValue: null,
        description: 'Thickest width for border',
        name: 'thick',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderWidthValues'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderWidthValues'
        }],
        required: true,
        type: {
          name: 'BorderWidth<string | number>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderColorValues.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderColorValues',
    methods: [],
    props: {
      color: {
        defaultValue: null,
        description: 'Color for all borders; Default is `colors.lightShade`',
        name: 'color',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderColorValues'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderColorValues'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderTypes.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderTypes',
    methods: [],
    props: {
      thin: {
        defaultValue: null,
        description: 'Full `border` property string computed using `border.width.thin` and `border.color`',
        name: 'thin',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderTypes'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderTypes'
        }],
        required: true,
        type: {
          name: 'Border<string | number>'
        }
      },
      thick: {
        defaultValue: null,
        description: 'Full `border` property string computed using `border.width.thick` and `border.color`',
        name: 'thick',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderTypes'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderTypes'
        }],
        required: true,
        type: {
          name: 'Border<string | number>'
        }
      },
      editable: {
        defaultValue: null,
        description: 'Full editable style `border` property string computed using `border.width.thick` and `border.color`',
        name: 'editable',
        parent: {
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderTypes'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/borders.ts',
          name: '_EuiThemeBorderTypes'
        }],
        required: true,
        type: {
          name: 'Border<string | number>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFocus.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFocus',
    methods: [],
    props: {
      color: {
        defaultValue: null,
        description: 'Default color of the focus ring, some components may override this property',
        name: 'color',
        parent: {
          fileName: 'app/src/global_styling/variables/states.ts',
          name: '_EuiThemeFocus'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/states.ts',
          name: '_EuiThemeFocus'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      width: {
        defaultValue: null,
        description: 'Thickness of the outline',
        name: 'width',
        parent: {
          fileName: 'app/src/global_styling/variables/states.ts',
          name: '_EuiThemeFocus'
        },
        declarations: [{
          fileName: 'app/src/global_styling/variables/states.ts',
          name: '_EuiThemeFocus'
        }],
        required: true,
        type: {
          name: 'BorderWidth<string | number>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeAnimationSpeed.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeAnimationSpeed',
    methods: [],
    props: {
      normal: {
        defaultValue: null,
        description: '',
        name: 'normal',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      extraFast: {
        defaultValue: null,
        description: '',
        name: 'extraFast',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      fast: {
        defaultValue: null,
        description: '',
        name: 'fast',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      slow: {
        defaultValue: null,
        description: '',
        name: 'slow',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      extraSlow: {
        defaultValue: null,
        description: '',
        name: 'extraSlow',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeAnimationEasing.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeAnimationEasing',
    methods: [],
    props: {
      bounce: {
        defaultValue: null,
        description: '',
        name: 'bounce',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationTimingFunction'
        }
      },
      resistance: {
        defaultValue: null,
        description: '',
        name: 'resistance',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationTimingFunction'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeLevelsProps.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeLevelsProps',
    methods: [],
    props: {
      header: {
        defaultValue: null,
        description: '',
        name: 'header',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      menu: {
        defaultValue: null,
        description: '',
        name: 'menu',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      mask: {
        defaultValue: null,
        description: '',
        name: 'mask',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      navigation: {
        defaultValue: null,
        description: '',
        name: 'navigation',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      content: {
        defaultValue: null,
        description: '',
        name: 'content',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      toast: {
        defaultValue: null,
        description: '',
        name: 'toast',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      modal: {
        defaultValue: null,
        description: '',
        name: 'modal',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      flyout: {
        defaultValue: null,
        description: '',
        name: 'flyout',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      maskBelowHeader: {
        defaultValue: null,
        description: '',
        name: 'maskBelowHeader',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'ZIndex'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}